"use client";
import { useInfiniteQuery } from "@tanstack/react-query";
import { fetch } from "libs";
import { GET_MODEL_CREATIONS_STAR_SORT } from "api";
import { useAppContext } from "hooks";
import { ImageGeneration, ResponseGeneration } from "types";


const fetchGeneration = async (
  id: string,
  pageParam: number = 1,
  pageSize: number = 8
): Promise<ResponseGeneration> => {
  const response = await fetch(`${GET_MODEL_CREATIONS_STAR_SORT(id)}?page=${pageParam}&page_size=${pageSize}`);
  return response as ResponseGeneration;  // ✅ Explicitly cast the response
};


export const useGetModelCreationStarSort = (pageSize = 8, id?: string) => {
  const { jwt } = useAppContext();

  return useInfiniteQuery<ResponseGeneration, Error>({
    queryKey: ["generation", id],
    queryFn: ({ pageParam }) => fetchGeneration(id!, (pageParam as number) || 1, pageSize), // ✅ Cast `pageParam` to `number`
    initialPageParam: 1,  // ✅ Ensure a valid starting page
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      return nextPage <= Math.ceil((lastPage?.total_image_generations ?? 0) / pageSize)
        ? nextPage
        : undefined;
    },
    enabled: !!id && !!jwt,
  });
};





export default useGetModelCreationStarSort;